import { Target, Wrench } from "lucide-react";

export default function Maintenance() {
  return (
    <div data-testid="maintenance-screen" className="min-h-screen flex items-center justify-center px-6 blueprint-grid relative">
      <div className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-background/20" />
      <div className="relative z-10 max-w-lg w-full text-center">
        <div className="flex items-center justify-center gap-2 mb-8">
          <div className="w-8 h-8 bg-primary flex items-center justify-center">
            <Target className="w-4 h-4 text-primary-foreground" />
          </div>
          <span className="font-display font-semibold tracking-tight text-xl">GetBidClear</span>
        </div>
        <div className="w-14 h-14 mx-auto mb-6 flex items-center justify-center border border-border bg-card">
          <Wrench className="w-6 h-6 text-primary" />
        </div>
        <h1 className="text-3xl sm:text-4xl tracking-tight font-medium font-display">Under Maintenance</h1>
        <p className="text-muted-foreground mt-4 leading-relaxed">
          GetBidClear is currently undergoing scheduled upgrades. We will be back online shortly.
        </p>
      </div>
    </div>
  );
}
